import merge from 'lodash/merge';
import { TFunction } from 'i18next';

import { getDefaultDlpConfig, getDlpTemplateConfig } from './cfg.dlp.default'; //   getTargetProperty,

const cfg = {
  policyType: 41,
  policySubType: 0,
  holderType: 2,
  // tmDpfilters: {
  //   dpMipLabelName: '',
  // },
};

export function getDlpTeamsTemplateConfig(
  t: TFunction<'translation'>,
  accountEmail: string | undefined,
  mipEnabled: boolean
) {
  let ntfI18nReplaceKeys = [];
  if (mipEnabled) {
    ntfI18nReplaceKeys = [
      'policy.policyTemplate.MT.tmDpfilters.notification.ntfAdminSubject',
      'policy.policyTemplate.MT.tmDpfilters.notification.ntfInternalRecipientSubject',
      'policy.policyTemplate.MIP_MT.tmDpfilters.notification.ntfAdminMessage',
      'policy.policyTemplate.MIP_MT.tmDpfilters.notification.ntfInternalRecipientMessage',
    ];
  } else {
    ntfI18nReplaceKeys = [
      'policy.policyTemplate.MT.tmDpfilters.notification.ntfAdminMessage',
      'policy.policyTemplate.MT.tmDpfilters.notification.ntfAdminSubject',
      'policy.policyTemplate.MT.tmDpfilters.notification.ntfInternalRecipientMessage',
      'policy.policyTemplate.MT.tmDpfilters.notification.ntfInternalRecipientSubject',
    ];
  }
  const tempConfig = getDefaultDlpConfig();
  merge(tempConfig, cfg);
  return getDlpTemplateConfig(
    t,
    tempConfig,
    accountEmail,
    [],
    ntfI18nReplaceKeys
  );
}
